import { ReactElement } from "react";

export const MobilePlusMenuSpacing = (): ReactElement => {
	return (
		<div className="preserve-space-for-mobile-plus-button" />
	);
};
MobilePlusMenuSpacing.displayName = "VirtualList.MobilePlusMenuSpacing";